import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'
import { primitiveValue } from '@fusion-advantage/backcompat'

// ANY_SELECTED(cid, sub1, sub2, ...) is TRUE when any of the listed
// subconcepts of cid is selected (truthy, like VALUE(cid, sub) in an IF)
export const AnySelectedFunction: HelperFunction = {
	tokenName: 'ANY_SELECTED',
	nodeType: functionNodeTypes.AnySelected,
	evaluate(node, evaluateExpr, context) {
		const args = node.arguments
		if (args.length < 2) {
			return err(evaluatorErrorWithNode('ANY_SELECTED function expects a concept and at least one subconcept', node))
		}
		const conceptResult = evaluateExpr(args[0])
		if (conceptResult.isErr()) return err(conceptResult.error)
		if (typeof conceptResult.value !== 'string') {
			return err(evaluatorErrorWithNode('ANY_SELECTED function first argument must evaluate to a string', node))
		}
		let selected = false
		for (const arg of args.slice(1)) {
			const subconceptResult = evaluateExpr(arg)
			if (subconceptResult.isErr()) return err(subconceptResult.error)
			if (typeof subconceptResult.value !== 'string') {
				return err(evaluatorErrorWithNode('ANY_SELECTED function subconcept arguments must evaluate to strings', node))
			}
			const rPrimitive = primitiveValue(context.substatusValue(conceptResult.value, subconceptResult.value))
			if (rPrimitive.isErr()) {
				return err(evaluatorErrorWithNode('ANY_SELECTED function expects primitive status values', node))
			}
			if (rPrimitive.value) selected = true
		}
		return ok(selected)
	}
}
